// src/components/reports/shared/ReportLayout.tsx
import React, { forwardRef } from "react";
import DocumentHeader from "./Header.tsx";
import DocumentFooter from "./Footer.tsx";

interface ReportLayoutProps {
  headerProps: any;
  footerProps: any;
  children: React.ReactNode;
  scale?: number;
}

const ReportLayout = forwardRef<HTMLDivElement, ReportLayoutProps>(
  ({ headerProps, footerProps, children, scale = 1 }, ref) => {
    return (
      <div className="flex justify-center overflow-auto">
        
        <div
          ref={ref}
          className="bg-white shadow-lg rounded-lg p-8"
          style={{
          width: "210mm",           
          minHeight: "297mm",       
          boxSizing: "border-box",  
          transform: `scale(${scale})`,
          transformOrigin: "top left", 
          overflow: "auto",        
        }}
        >
          <DocumentHeader {...headerProps} />
          <div className="mt-6">{children}</div>
          <div className="mt-8">
            <DocumentFooter {...footerProps} />
          </div>
        </div>
      </div>
    );
  }
);


export default ReportLayout;
